import React from 'react';
import useAlertBannersBox from './hooks/use-alert-banners-box';
import AlertBanner from '../../../component_library/components/AlertBanner/AlertBanner';
import HtmlBox from '../../../component_library/components/HtmlBox/HtmlBox';
import type { IAlertData } from '../../../dotcms/dotcms-models/dotcms-alert';
import { DataElementId } from '../../../constants/data-element-tracking-ids';
import { useThemeToken } from '../../../hooks/use-get-theme/use-get-theme';
import { BoxWithId } from '../../../component_library/components/BoxWithId/BoxWithId';

interface IProps {
  extraAlertsFilter?: (
    value: IAlertData,
    index: number,
    array: IAlertData[],
  ) => boolean;
}

const AlertBannerBox: React.FC<IProps> = ({ extraAlertsFilter }) => {
  const { theme, alerts, closeAlert } = useAlertBannersBox();
  const themeToken = useThemeToken();
  const filteredAlerts = extraAlertsFilter
    ? alerts.filter(extraAlertsFilter)
    : alerts;

  return (
    <BoxWithId dataElementId={DataElementId.ALERT_BOX}>
      {filteredAlerts.map((alert) => (
        <AlertBanner
          dataElementId={`${DataElementId.ALERT_BOX}-${alert.identifier}`}
          key={alert.identifier}
          theme={theme}
          themeToken={themeToken}
          isClosable={alert.isClosable}
          onClose={alert.isClosable ? () => closeAlert(alert) : undefined}
          variant={alert.alertTheme}
        >
          <HtmlBox html={alert.text} />
        </AlertBanner>
      ))}
    </BoxWithId>
  );
};

export default AlertBannerBox;
